export const contractsDummyData = [
  {
    id: 1,
    title: "Web App Development | E-Commerce",
    owner: "Mr. Pardi",
    created: "20 April 2024",
    status: "Signed",
    signatory: "Mr. Pardi & Mr. Calimlim",
    scopeOfServices:
      "Development of a custom web application for an e-commerce platform, including front-end and back-end development, user authentication, payment integration, and deployment.",
    payment:
      "Total project cost: $50,000. Payment schedule: 50% upfront ($25,000), 25% upon milestone 1 completion ($12,500), 25% upon project completion ($12,500).",
    ipRights:
      "Company retains ownership of all intellectual property rights. Upon full payment, client receives a non-exclusive, perpetual license to use the developed application.",
    confidentiality:
      "Both parties agree to keep confidential all information disclosed during the course of this Agreement, including but not limited to business plans, technical data, and customer information.",
    termAndTermination:
      "The agreement shall commence on 1 May 2024 (Effective Date) and continue until the Services are completed, estimated to be 1 December 2024. Either party may terminate the Agreement with 30 days' written notice if the other party is in material breach of any terms.",
    miscellaneous:
      "Any amendments to this Agreement must be made in writing and signed by both parties. This Agreement constitutes the entire agreement between the parties and supersedes all prior agreements and understandings.",
    governingLaw:
      "This Agreement shall be governed by and construed in accordance with the laws of the State of California.",
    category: "Web Application"
  },

  {
    id: 2,
    title: "Web App | Maintenance Contract",
    owner: "Mr. Boneo",
    created: "29 Jan 2024",
    status: "Signed",
    signatory: "Mr. Boneo & Mrs. Valdez",
    scopeOfServices:
      "Provision of ongoing maintenance and support for the web application, including bug fixes, performance monitoring, and security updates.",
    payment:
      "Total annual cost: $12,000, payable in monthly installments of $1,000.",
    ipRights:
      "All intellectual property rights remain with the client. The service provider is granted access rights for maintenance purposes only.",
    confidentiality:
      "All client data and information accessed during maintenance shall be kept confidential and not disclosed to any third party.",
    termAndTermination:
      "The agreement is effective from 1 February 2024 and will continue for one year. It may be terminated by either party with 30 days' written notice.",
    miscellaneous:
      "Changes to this agreement must be made in writing and signed by both parties. This document represents the entire agreement.",
    governingLaw:
      "This agreement is governed by the laws of the State of New York.",
    category: "Web Application"
  },
  {
    id: 3,
    title: "Website Landing Page",
    owner: "Mr. Boneo",
    created: "06 May 2024",
    status: "Request Changes",
    signatory: "",
    scopeOfServices:
      "Design and development of a landing page for marketing purposes, including SEO optimization and responsive design.",
    payment:
      "Total cost: $3,000. Payment schedule: 50% upfront ($1,500), 50% upon completion ($1,500).",
    ipRights:
      "The client retains all intellectual property rights. Upon full payment, the client receives all design files and assets.",
    confidentiality:
      "All project details and business information shared during the project will remain confidential.",
    termAndTermination:
      "The agreement is effective from 10 May 2024 until the completion of the project, estimated by 30 May 2024.",
    miscellaneous:
      "Amendments to this agreement must be in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of California.",
    category: "Website"
  },
  {
    id: 4,
    title: "E-Commerce Landing Website",
    owner: "Mr. Boneo",
    created: "20 May 2024",
    status: "Pending",
    signatory: "",
    scopeOfServices:
      "Development of an e-commerce landing website to showcase products and facilitate online sales, including payment gateway integration.",
    payment:
      "Total cost: $7,500. Payment terms to be determined upon agreement signing.",
    ipRights:
      "The client will own all intellectual property rights upon full payment.",
    confidentiality:
      "All information related to the project will be kept confidential by both parties.",
    termAndTermination:
      "The term of the agreement will be specified upon finalizing the contract.",
    miscellaneous:
      "Any changes to the agreement must be made in writing and signed by both parties.",
    governingLaw:
      "This agreement will be governed by the laws of the State of Texas.",
    category: "Website"
  },
  {
    id: 5,
    title: "Portfolio Website",
    owner: "Mr. Alde",
    created: "06 Feb 2024",
    status: "Signed",
    signatory: "Mr. Alde & Mr. Campbell",
    scopeOfServices:
      "Design and development of a personal portfolio website to showcase projects, skills, and contact information.",
    payment:
      "Total cost: $2,500. Payment schedule: 50% upfront ($1,250), 50% upon completion ($1,250).",
    ipRights:
      "The client retains all rights to the content and design upon full payment.",
    confidentiality:
      "All information shared for the creation of the portfolio will remain confidential.",
    termAndTermination:
      "The agreement is effective from 10 February 2024 until the project is completed, estimated by 28 February 2024.",
    miscellaneous:
      "Modifications to the agreement must be in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of Florida.",
    category: "Website"
  },
  {
    id: 6,
    title: "Maintenance Services",
    owner: "Mr. Aron",
    created: "15 May 2024",
    status: "Pending",
    signatory: "",
    scopeOfServices:
      "Ongoing maintenance services for existing software applications, including updates, patches, and technical support.",
    payment: "Total cost: $10,000 per year, billed monthly at $833.33.",
    ipRights:
      "All intellectual property rights remain with the client, with the service provider having necessary access rights for maintenance.",
    confidentiality:
      "All accessed data and client information will be kept confidential.",
    termAndTermination:
      "The agreement will begin on 1 June 2024 and continue for one year. Termination requires 30 days' notice.",
    miscellaneous:
      "Amendments to this agreement must be in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of Washington.",
    category: "Other"
  },
  {
    id: 7,
    title: "Support and Maintenance Contract",
    owner: "Mr. Edillor",
    created: "05 Nov 2023",
    status: "Signed",
    signatory: "Mr. Edillor & Ms. Scott",
    scopeOfServices:
      "Provision of support and maintenance services for the client’s software, including troubleshooting and regular updates.",
    payment:
      "Annual cost: $15,000, payable in quarterly installments of $3,750.",
    ipRights:
      "Client retains all intellectual property rights. Service provider has access rights for support purposes.",
    confidentiality:
      "All information related to the client's software and data will be kept confidential.",
    termAndTermination:
      "Effective from 1 December 2023 and continues for one year. Either party may terminate with 30 days' notice.",
    miscellaneous:
      "Any changes must be documented in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of Illinois.",
    category: "Other"
  },
  {
    id: 8,
    title: "Mobile App Development",
    owner: "Mr. Aron",
    created: "26 May 2024",
    status: "Signed",
    signatory: "Mr. Aron & Mr. Inova",
    scopeOfServices:
      "Development of a mobile application for both iOS and Android platforms, including design, development, and testing.",
    payment:
      "Total cost: $60,000. Payment schedule: 30% upfront ($18,000), 40% upon beta release ($24,000), 30% upon final release ($18,000).",
    ipRights:
      "The client retains all intellectual property rights upon full payment. The service provider will have rights to use the app in their portfolio.",
    confidentiality: "All project details and data will be kept confidential.",
    termAndTermination:
      "The agreement starts on 1 June 2024 and continues until project completion, estimated by 1 December 2024.",
    miscellaneous:
      "Modifications must be in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of California.",
    category: "Mobile Application"
  },
  {
    id: 9,
    title: "Contact Website Frontend",
    owner: "Mr. Alde",
    created: "20 Nov 2023",
    status: "Signed",
    signatory: "Mr. Alde & Ms. Robles",
    scopeOfServices:
      "Development of the frontend for a contact management website, including responsive design and integration with backend services.",
    payment:
      "Total cost: $5,000. Payment schedule: 50% upfront ($2,500), 50% upon completion ($2,500).",
    ipRights: "Client owns all intellectual property rights upon full payment.",
    confidentiality:
      "All project-related information will be kept confidential.",
    termAndTermination:
      "Effective from 1 December 2023 until project completion, estimated by 20 December 2023.",
    miscellaneous: "Changes must be in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of New York.",
    category: "Website"
  },
  {
    id: 10,
    title: "Open Source Software",
    owner: "Mr. Alde",
    created: "29 April 2024",
    status: "Pending",
    signatory: "",
    scopeOfServices:
      "Development of an open-source software project, including initial coding, documentation, and community guidelines.",
    payment:
      "Total cost: $8,000. Payment terms to be determined upon agreement signing.",
    ipRights:
      "The software will be released under an open-source license, with contributions credited appropriately.",
    confidentiality:
      "Project details will be public, but sensitive information will remain confidential.",
    termAndTermination:
      "The term will be specified upon finalizing the contract.",
    miscellaneous:
      "Modifications must be documented in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of Oregon.",
    category: "Other"
  },
  {
    id: 11,
    title: "POS Desktop App",
    owner: "Mr. Boneo",
    created: "24 Jan 2024",
    status: "Signed",
    signatory: "Mr. Boneo & Mr. Santiago",
    scopeOfServices:
      "Development of a point-of-sale (POS) desktop application, including inventory management, sales tracking, and reporting features.",
    payment:
      "Total cost: $20,000. Payment schedule: 50% upfront ($10,000), 50% upon completion ($10,000).",
    ipRights:
      "The client will own all intellectual property rights upon full payment.",
    confidentiality:
      "All business and technical information will be kept confidential.",
    termAndTermination:
      "Effective from 1 February 2024 until project completion, estimated by 30 April 2024.",
    miscellaneous: "Any changes must be in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of Texas.",
    category: "Desktop Application"
  },
  {
    id: 12,
    title: "Software Integration",
    owner: "Mr. Aron",
    created: "20 April 2024",
    status: "Request Changes",
    signatory: "",
    scopeOfServices:
      "Integration of third-party software with the client's existing systems, ensuring compatibility and optimal performance.",
    payment:
      "Total cost: $15,000. Payment schedule to be determined upon final agreement.",
    ipRights:
      "Client retains all intellectual property rights to the integrated systems.",
    confidentiality:
      "All integration processes and data will remain confidential.",
    termAndTermination:
      "The agreement will begin upon finalizing terms and will end upon successful integration.",
    miscellaneous:
      "Amendments must be made in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of New Jersey.",
    category: "Other"
  },
  {
    id: 13,
    title: "Software Upgrade E-Commerce",
    owner: "Mr. Edillor",
    created: "21 May 2024",
    status: "Pending",
    signatory: "",
    scopeOfServices:
      "Upgrading the client's existing e-commerce software to enhance performance, add new features, and improve security.",
    payment:
      "Total cost: $25,000. Payment terms to be determined upon agreement signing.",
    ipRights:
      "Client retains all intellectual property rights to the upgraded software.",
    confidentiality:
      "All upgrade details and client data will be kept confidential.",
    termAndTermination:
      "The agreement will commence upon signing and end upon project completion, estimated by 1 September 2024.",
    miscellaneous: "Any changes must be in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of Colorado.",
    category: "Desktop Application"
  },
  {
    id: 14,
    title: "HR Payroll Web App",
    owner: "Mr. Edillor",
    created: "01 Dec 2023",
    status: "Signed",
    signatory: "Mr. Edillor & Mr. Smith",
    scopeOfServices:
      "Development of a web application for managing HR payroll, including employee data management, payroll processing, and reporting.",
    payment:
      "Total cost: $30,000. Payment schedule: 40% upfront ($12,000), 30% upon mid-point review ($9,000), 30% upon completion ($9,000).",
    ipRights:
      "Client retains all intellectual property rights upon full payment.",
    confidentiality: "All HR and payroll data will be kept confidential.",
    termAndTermination:
      "Effective from 5 December 2023 until project completion, estimated by 30 March 2024.",
    miscellaneous:
      "Any amendments must be in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of Georgia.",
    category: "Web Application"
  },
  {
    id: 15,
    title: "Food Mobile App",
    owner: "Mr. Edillor",
    created: "12 Jan 2024",
    status: "Signed",
    signatory: "Mr. Edillor & Mr. Lopez",
    scopeOfServices:
      "Development of a mobile application for food delivery services, including user registration, restaurant listings, order management, and payment processing.",
    payment:
      "Total cost: $40,000. Payment schedule: 25% upfront ($10,000), 50% upon beta release ($20,000), 25% upon final release ($10,000).",
    ipRights:
      "Client retains all intellectual property rights upon full payment.",
    confidentiality: "All project and user data will be kept confidential.",
    termAndTermination:
      "Effective from 15 January 2024 until project completion, estimated by 15 July 2024.",
    miscellaneous:
      "Modifications must be in writing and signed by both parties.",
    governingLaw:
      "This agreement is governed by the laws of the State of Nevada.",
    category: "Mobile Application"
  }
];
